module["exports"] = [
  "Dr.",
  "Prof."
];
